/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { LogLevel, StaticTelemetry } from '@msdyn365-commerce/telemetry-internal';
import { IActionContext } from '../interfaces';
export namespace requestHookRegistrar {
    export enum RequestReaderAction {
        send,
        redirect
    }
    export interface IRequestReaderOutput {
        action: RequestReaderAction;
        parameters: string[] | undefined;
    }
    type requestReaderPlugin = (ctx: IActionContext) => Promise<IRequestReaderOutput | undefined>;
    // more plugins will be added future.
    interface IRequestHookBase {
        requestReaderPlugin: requestReaderPlugin;
    }

    // TODO: more plugins will be added for each hook.
    export interface IInitialHook extends IRequestHookBase {}
    export interface IPreRenderHook extends IRequestHookBase {}
    export interface IPostRenderHook extends IRequestHookBase {}

    interface IHookRegistration {
        initialHook?: IInitialHook;
        preRenderHook?: IPreRenderHook;
        postRenderHook?: IPostRenderHook;
    }
    export const requestHookRegistration: IHookRegistration = {};

    const createHook = (hookType: 'initial' | 'pre-render' | 'post-render') => (options: IRequestHookBase) => {
        switch (hookType) {
            case 'initial':
                if (requestHookRegistration.initialHook) {
                    StaticTelemetry.log(LogLevel.Error, `initialHook is already registered, please avoid duplicate registration`);
                    throw new Error('Initial hook is already registered, can not register duplicate initial hook');
                }
                requestHookRegistration.initialHook = options;
                break;
            case 'pre-render':
                if (requestHookRegistration.preRenderHook) {
                    StaticTelemetry.log(LogLevel.Error, `pre-render is already registered, please avoid duplicate registration`);
                    throw new Error('pre-render hook is already registered, can not register duplicate pre-render hook');
                }
                requestHookRegistration.preRenderHook = options;
                break;
            case 'post-render':
                if (requestHookRegistration.postRenderHook) {
                    StaticTelemetry.log(LogLevel.Error, `post-render is already registered, please avoid duplicate registration`);
                    throw new Error('post-render hook is already registered, can not register duplicate post-render hook');
                }
                requestHookRegistration.postRenderHook = options;
                break;
            default:
                StaticTelemetry.log(LogLevel.Warning, `unsupported request hook registration ${hookType}`);
                break;
        }
    };

    export const createInitialHook = createHook('initial');
    export const createpreRenderHook = createHook('pre-render');
    export const createpostRenderHook = createHook('post-render');
}
